/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, {
    device,
    themeGet,
    layout,
    space,
    css,
    tinycolor,
} from '@doar/shared/styled';

import { Button } from '@doar/components';
import { FlattenSimpleInterpolation } from 'styled-components';

export const StyledHeader = styled.header`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    align-items: stretch;
    height: 55px;
    padding: 0;
    justify-content: flex-start;
    background-color: #fff;
    border-bottom: 1px solid
        ${(props) => themeGet('colors.border')(props) as string};
    ${device.large} {
        height: 60px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    ${(props) =>
        props.theme.name === 'cool' &&
        css`
            border-bottom-color: ${tinycolor(
                themeGet('colors.skinUi01')(props) as string
            )
                .lighten(45)
                .toString()};
            box-shadow: 0 0 25px
                ${tinycolor(themeGet('colors.skinUi01')(props) as string)
                    .setAlpha(0.1)
                    .toRgbString()};
        `};
    ${(props) =>
        props.theme.name === 'dark' &&
        css`
            background-color: ${(props_inner) =>
                themeGet('colors.gray900')(props_inner) as string};
            border-bottom-width: 0;
        `};
`;

export const StyledLogo = styled.div`
    padding-top: 0.33594rem;
    padding-bottom: 0.33594rem;
    margin-right: 1rem;
    font-size: 1.09375rem;
    line-height: inherit;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding-left: 15px;
    margin-right: 0;
    order: 1;
    ${device.large} {
        width: fit-content;
        min-width: 120px;
        padding: 0 0 0 20px;
    }
`;

interface INavbar {
    $isOpen?: boolean;
}

export const StyledNavbarWrap = styled.div<INavbar>`
    order: 3;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1060;
    visibility: hidden;
    opacity: 0;
    transition: all 0.4s;
    will-change: visibility, opacity;
    background-color: ${(props) =>
        props &&
        css`
            ${tinycolor(themeGet('colors.vulcan')(props) as string)
                .setAlpha(0.7)
                .toRgbString()}
        `};

    ${({ $isOpen }) =>
        $isOpen === true &&
        css`
            visibility: visible;
            opacity: 1;
        `}
    ${device.large} {
        width: auto;
        padding: 0 10px;
        position: relative;
        top: auto;
        left: auto;
        bottom: auto;
        overflow: visible;
        display: flex;
        justify-content: center;
        order: 2;
        transform: none;
        z-index: auto;
        flex: 1;
        visibility: visible;
        opacity: 1;
        background: transparent;
        flex: 1;
        justify-content: center;
        align-items: center;
    }
`;

export const StyledNavbarMenu = styled.nav<INavbar>`
    width: 260px;
    height: 100%;
    transition: all 0.4s;
    will-change: transform;
    transform: translateX(-260px);
    z-index: 99999;
    position: relative;
    background-color: #fff;

    ${({ $isOpen }) =>
        $isOpen === true &&
        css`
            transform: translateX(0);
        `}
    ${device.large} {
        background-color: transparent;
        width: 100%;
        max-width: 1100px;
        margin-top: -3px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        transform: translateX(0);
        justify-content: center;
    }
    ${(props) =>
        props.theme.name !== 'dark' &&
        css`
            ${device.large} {
                background-color: transparent;
            }
        `}
    ${(props) =>
        props.theme.name === 'dark' &&
        css`
            background-color: ${(props_inner) =>
                themeGet('colors.darklighten5')(props_inner) as string};
            ${device.large} {
                background-color: transparent;
            }
        `}
`;

export const StyledNavbarHeader = styled.div`
    height: 55px;
    padding: 0 15px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${device.large} {
        display: none;
    }
    ${(props) =>
        props.theme.name !== 'dark' &&
        css`
            border-bottom: 1px solid
                ${(props_inner) =>
                    themeGet('colors.border')(props_inner) as string};
        `}
    ${(props) =>
        props.theme.name === 'dark' &&
        css`
            background-color: ${(props_inner) =>
                themeGet('colors.gray900')(props_inner) as string};

            a:last-child {
                &:hover,
                &:focus {
                    color: ${(props_inner) =>
                        themeGet('colors.white')(props_inner) as string};
                }
            }
        `}
`;

export const StyledNavbarBody = styled.div<INavbar>`
    padding: 25px 0;
    display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};

    ${device.large} {
        padding: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const StyledNavbarTitle = styled.h6`
    font-size: 10px;
    font-weight: 600;
    font-family: ${(props) => themeGet('fonts.interUi')(props) as string};
    letter-spacing: 0.7px;
    color: ${(props) => themeGet('colors.text3')(props) as string};
    text-transform: uppercase;
    display: block;
    margin-bottom: 15px;
    padding-left: 20px;
    ${device.large} {
        display: none;
    }
`;

export const StyleNavbarRight = styled.div`
    padding: 0 15px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    order: 2;
    ${device.xlarge} {
        width: fit-content;
    }
    ${device.large} {
        order: 3;
        padding: 0 20px 0 0;
    }
`;

export const StyledNavbarElement = styled(({ mt, mb, ml, mr, ...props }) => (
    <div {...props} />
))`
    ${space};
    ${layout};
    .header-icon {
        width: 16px;
        height: 16px;
        stroke-width: 3px;

        ${device.small} {
            width: 20px;
            height: 20px;
            stroke-width: 2.25px;
        }
        ${({ theme }) =>
            theme.name !== 'dark' &&
            css`
                color: ${(props) => themeGet('colors.text')(props) as string};
            `}
        ${({ theme }) =>
            theme.name === 'dark' &&
            css`
                color: ${(props) =>
                    themeGet('colors.gray300')(props) as string};
                &:hover,
                &:focus {
                    color: ${(props) =>
                        themeGet('colors.white')(props) as string};
                }
            `}
    }
`;

interface IMenuBtn {
    $hasSidebar?: boolean;
    $sidebarOpen?: boolean;
    $bodyOpen?: boolean;
}

export const StyledMenuBtn = styled(({ ...rest }) => (
    <Button {...rest} />
))<IMenuBtn>`
    margin-left: 18px;
    svg {
        color: ${(props) => themeGet('colors.text3')(props) as string};
    }

    display: block;

    // ✅ Fix: Use an explicit return or ternary operator to ensure undefined if false
    ${({
        $hasSidebar,
        $sidebarOpen,
    }): FlattenSimpleInterpolation | undefined => {
        if ($hasSidebar && $sidebarOpen) {
            return css`
                display: none;
            `;
        }
        return undefined; // Explicitly return undefined when the condition is false
    }}

    ${device.large} {
        display: none;
    }

    ${({ theme }) =>
        theme.name === 'dark' &&
        css`
            &:hover {
                color: ${(props) => themeGet('colors.white')(props) as string};
            }
        `}
`;

export const StyledSidebarBtn = styled(({ ...rest }) => (
    <Button {...rest} />
))<IMenuBtn>`
    margin-left: 18px;
    svg {
        color: ${(props) => themeGet('colors.text3')(props) as string};
    }
    ${device.small} {
        margin-left: 20px;
    }
    ${device.large} {
        display: none;
    }
    // ✅ Fix: Use an explicit return or ternary operator
    ${({ $sidebarOpen, $bodyOpen }): FlattenSimpleInterpolation | undefined => {
        // This is line 316
        if (!$sidebarOpen && !$bodyOpen) {
            return css`
                ${device.mdToLg} {
                    display: none;
                }
            `;
        }
        return undefined; // Explicitly return undefined
    }}

    // ✅ Fix: Apply the same pattern here if it's also causing an error
    ${({ $sidebarOpen, $bodyOpen }): FlattenSimpleInterpolation | undefined => {
        if ($sidebarOpen === true && !$bodyOpen) {
            return css`
                display: none;
            `;
        }
        return undefined;
    }}
    // ✅ Fix: Apply the same pattern here if it's also causing an error
    ${({ $bodyOpen, $sidebarOpen }): FlattenSimpleInterpolation | undefined => {
        if ($bodyOpen === true && $sidebarOpen === true) {
            return css`
                display: block;
            `;
        }
        return undefined;
    }}
    ${({ theme }) =>
        theme.name === 'dark' &&
        css`
            &:hover {
                color: ${(props) => themeGet('colors.white')(props) as string};
            }
        `}
`;

export const StyledNavList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    width: 100%;

    ${device.large} {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
`;

export const StyledNavItem = styled.li`
    @media (min-width: ${(props) => props.theme.media.lg as string}) {
        margin: 0 10px;
    }
`;

export const StyledNavLink = styled.a`
    display: block;
    padding: 10px 20px;
    color: ${(props) => themeGet('colors.text2')(props) as string};
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;

    &:hover,
    &:focus {
        color: ${(props) => themeGet('colors.primary')(props) as string};
    }

    ${(props) =>
        props.theme.name === 'dark' &&
        css`
            color: ${(props_inner) =>
                themeGet('colors.gray300')(props_inner) as string};
            &:hover,
            &:focus {
                color: ${(props_inner) =>
                    themeGet('colors.white')(props_inner) as string};
            }
        `}

    ${device.large} {
        padding: 15px 15px;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        &:hover {
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: ${(props) =>
                    themeGet('colors.primary')(props) as string};
            }
        }
    }
`;

export const StyledSignInButton = styled(Button)`
    padding: 8px 15px;
    font-size: 14px;
    ${device.small} {
        padding: 10px 20px;
    }
`;
